/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskImportFileResponse
 */
export interface TaskImportFileResponse {
    /**
     * 
     * @type {string}
     * @memberof TaskImportFileResponse
     */
    fileType?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskImportFileResponse
     */
    mimeType?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskImportFileResponse
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskImportFileResponse
     */
    fileExtension?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskImportFileResponse
     */
    fileSize?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskImportFileResponse
     */
    sha512?: string;
}

/**
 * Check if a given object implements the TaskImportFileResponse interface.
 */
export function instanceOfTaskImportFileResponse(value: object): value is TaskImportFileResponse {
    return true;
}

export function TaskImportFileResponseFromJSON(json: any): TaskImportFileResponse {
    return TaskImportFileResponseFromJSONTyped(json, false);
}

export function TaskImportFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskImportFileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
        'mimeType': json['mimeType'] == null ? undefined : json['mimeType'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileExtension': json['fileExtension'] == null ? undefined : json['fileExtension'],
        'fileSize': json['fileSize'] == null ? undefined : json['fileSize'],
        'sha512': json['sha512'] == null ? undefined : json['sha512'],
    };
}

export function TaskImportFileResponseToJSON(json: any): TaskImportFileResponse {
    return TaskImportFileResponseToJSONTyped(json, false);
}

export function TaskImportFileResponseToJSONTyped(value?: TaskImportFileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileType': value['fileType'],
        'mimeType': value['mimeType'],
        'fileName': value['fileName'],
        'fileExtension': value['fileExtension'],
        'fileSize': value['fileSize'],
        'sha512': value['sha512'],
    };
}

